
<template lang="pug">
  div.press
    div.banner
      img(src="../../assets/images/press.jpg",
          style="object-position: 50% 50%")
    div.content
      div.title
        h1 新闻发布
        //- ul.sub-nav
        //-   router-link(tag="li", :to="{name: 'press'}") Press
        //-   router-link(tag="li", :to="{name: 'press'}") Press
      div.article-sets.grid(ref="masonry")
        NewsItem.news-item(v-for="(news, $index) in pressList",
                          :key="news.id",
                          :relayout="relayout",
                          :class="$index ? 'item-normal' : 'item-special'",
                          :news="news")

</template>
<script>
import Masonry from 'masonry-layout'
import NewsItem from '@/components/Press/NewsItem.vue'
import { getPress } from '@/services/index'
export default {
  name: 'Press',
  data () {
    return {
      pressList: null,
      masonry: null,
      count: 0,
      options: {
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  created () {
  },
  mounted () {
    getPress()
      .then(res => {
        this.pressList = res.data
      })
      .then(() => {
        this.$nextTick(() => {
          this.masonry = new Masonry(this.$refs.masonry, {
            itemSelector: '.news-item',
            columnWidth: '.item-normal',
            percentPosition: true,
            horizontalOrder: false,
            resize: true
          })
        })

        setTimeout(() => {
          if (this.masonry) {
            this.masonry.layout()
          }
        }, 300)
      })
  },
  methods: {
    relayout () {
      if (this.masonry) {
        this.masonry.layout()
        this.count++
      }
      if (this.pressList.length === this.count) {
        this.$nextTick(() => {
          this.masonry.layout()
        })
      }
    }
  },
  components: {
    NewsItem
  }
}
</script>

<style lang="scss" scoped>
.banner img {
  max-width: 100%;
  // max-height: 60vh;
  width: 100%;
  object-fit: cover;
  height: 43.5vw;
}

  .title {
    padding:  0 15px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
     h1 {
       font-size: 2.43rem;
     }
     ul {
       margin-right: 2rem;
       font-weight: 500;
       line-height: 1.8rem;
     }
  }
  .content {
    max-width: 80rem;
    margin:  0 auto;
  }
  .article-sets {
    background: linear-gradient(to bottom, #fff 0%, #f6f6fb 500px);
    padding-bottom: 50px;
    overflow: visible;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: center;
  }

  .article-sets:after {
    content: '';
    display: block;
    clear: both;
  }

  .news-item {
    margin-bottom: 5px;
    width: 100%;
  }

@media only screen and (min-width: 768px) {

    // .news-item:first-child {
    //   width: 100%;
    // }
     .news-item{
      width: 50%;
      padding: 15px;
    }
}

@media (min-width: 992px) {
  // .news-item:first-child {
  //    width: 66.66666%;
  //   }
  .news-item{
      width: 33.33333%;
      padding: 15px;
    }
}

</style>
